module.exports = __webpack_public_path__ + "img/icono-13-2.ff461c0e.png";